<section class="px-4 py-20">
  <h2 class="text-2xl sm:text-3xl font-bold mb-12 text-center text-gray-100">
    ¿Por qué elegir Altair Parfum?
  </h2>

  <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 lg:gap-8">
    <app-galaxy-card padding="lg">
      <div galaxy-card-content class="text-center">
        <svg class="w-12 h-12 mx-auto mb-4 text-cyan-400" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <h3 class="text-lg font-semibold mb-2 text-gray-100">100% Originales</h3>
        <p class="text-gray-400 text-sm">Importados directamente de las mejores casas de perfumería árabe (Lattafa, Afnan, etc.).</p>
      </div>
    </app-galaxy-card>

    <app-galaxy-card padding="lg">
      <div galaxy-card-content class="text-center">
        <svg class="w-12 h-12 mx-auto mb-4 text-emerald-400" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <h3 class="text-lg font-semibold mb-2 text-gray-100">Dupes de Lujo Inteligentes</h3>
        <p class="text-gray-400 text-sm">Disfruta el aroma y la estela de los perfumes nicho más caros del mundo a una fracción de su costo.</p>
      </div>
    </app-galaxy-card>

    <app-galaxy-card padding="lg">
      <div galaxy-card-content class="text-center">
        <svg class="w-12 h-12 mx-auto mb-4 text-amber-400" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" />
        </svg>
        <h3 class="text-lg font-semibold mb-2 text-gray-100">Fijación Superior</h3>
        <p class="text-gray-400 text-sm">Alta concentración y aceites orientales que garantizan duración prolongada en piel y ropa.</p>
      </div>
    </app-galaxy-card>

    <app-galaxy-card padding="lg">
      <div galaxy-card-content class="text-center">
        <svg class="w-12 h-12 mx-auto mb-4 text-violet-400" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-9m18-0v-7.5A2.25 2.25 0 0017.25 9H15M6.75 11.25V6.75A2.25 2.25 0 019 4.5h6a2.25 2.25 0 012.25 2.25v4.5" />
        </svg>
        <h3 class="text-lg font-semibold mb-2 text-gray-100">Envíos Seguros</h3>
        <p class="text-gray-400 text-sm">Empaque especializado y pagos contraentrega o con pasarela segura.</p>
      </div>
    </app-galaxy-card>
  </div>
</section>
